<template>
  <Dialog
    v-model:visible="visible"
    modal
    :style="{ width: '400px' }"
    :draggable="false"
    :closable="true"
    :pt="{
      header: { class: 'p-0 justify-end' },
      headerIcons: { class: 'mr-2 mt-2' },
    }"
  >
    <div class="flex justify-center mb-4 mt-0">
      <div
        class="flex p-4 rounded-[50%] text-warning-800 bg-[var(--yellow-100)] border-[var(--yellow-700)]"
      >
        <span class="material-symbols-rounded text-[2rem] text-orange">warning</span>
      </div>
    </div>
    <div class="text-center">
      <h4 class="m-0 font-bold">{{ translate(`${LOCALE_PREFIX}.deleteConfirmation.header`) }}</h4>
    </div>
    <div class="text-center p-4 pb-0">
      <span class="text-[var(--text-color-secondary)]">
        {{ translate(`${deleteConfirmationMessagePrefix}.deleteConfirmation.message`) }}
      </span>
    </div>

    <template #footer>
      <div class="flex justify-center gap-3">
        <Button
          :label="translate(`${LOCALE_PREFIX}.deleteConfirmation.cancel`)"
          outlined
          severity="secondary"
          @click="closeDialog"
          class="border-none text-primary w-full"
        />
        <Button
          :label="translate(`${LOCALE_PREFIX}.deleteConfirmation.continue`)"
          @click="confirm"
          class="w-full"
        />
      </div>
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue';
import { useTranslation } from '@centric-os/helpers';
import { SitesLocalePrefix } from '@centric-os/sites/src/enums';
import { useEventBus } from '@vueuse/core';
import { StationAppConfigFormEventKey } from '@centric-os/sites/src/routes/app-config/components/shared/enums/form-event-keys.ts';
import { paymentInfoContextKey } from '../../../context';

// Set localization
const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_PAYMENT_INFO;

const paymentInfoContext = inject(paymentInfoContextKey, null);
const isCentricHub = computed<boolean>(() => paymentInfoContext?.isCentricHub.value ?? false);

const deleteConfirmationMessagePrefix = computed<string>(() =>
  isCentricHub.value ? 'sites.centricHub.paymentConfig' : LOCALE_PREFIX,
);

// Define visible ref
const visible = defineModel({
  type: Boolean,
  required: true,
});

// Set event bus for payment settings removal
const { emit: emitPaymentSettingsRemoved } = useEventBus<void>(
  StationAppConfigFormEventKey.PaymentSettingsRemovedStation,
);

// Method to close dialog
const closeDialog = (): void => {
  visible.value = false;
};

// Method to confirm delete
const confirm = async (): Promise<void> => {
  emitPaymentSettingsRemoved();
  closeDialog();
};
</script>
